import React, { Component } from 'react';
import PropTypes from 'prop-types';
import PlanImpact from '../../PlanImpact/PlanImpactContainer';
import AdvForm from '../../../CommonComponents/AdvForm';
import Footer from '../../Footer/FooterContainer';
import Loading from '../../Loading/LoadingView';
import {
  isNumeric,
  isNumericFormatted,
  isUuid,
  createCustomPropType,
} from '../../../../js/app/react/validators';
import ValidationErrors from '../../ValidationErrors/ValidationErrorsContainer';
import AdvInput, { advInputTextChanged } from '../../../CommonComponents/AdvInput';
import AdvInputWrapper from '../../../CommonComponents/AdvInputWrapper';
import SchoolSearch from '../../../CommonComponents/SchoolSearchInput';
import { inputNumericRadioClicked } from '../../../Profile/Accounts_react/AccountsUtils';
import EDUCATION_TYPE_OTHER from './SchoolTypeConstants';

const NATIONAL_AVERAGE = 0;
const SPECIFIC_SCHOOL = 1;

const costTypeOptions = [
  { label: 'National Average', value: NATIONAL_AVERAGE },
  { label: 'Specific School', value: SPECIFIC_SCHOOL },
];

const IN_STATE = 0;
const OUT_OF_STATE = 1;

const tuitionTypeOptions = [
  { label: 'In-State', value: IN_STATE },
  { label: 'Out-of-State', value: OUT_OF_STATE },
];

class SchoolTypeChangesView extends Component {
  constructor() {
    super();
    this.onMoneyInputBlur = this.onMoneyInputBlur.bind(this);
    this.onYearlyCostFocus = this.onYearlyCostFocus.bind(this);
  }
  componentDidMount() {
    const {
      fetchData,
      clientId,
      fpId,
      goalId,
      fetchInitialPlanImpact,
      whatIf,
      whatIfTemplate,
    } = this.props;
    fetchData(clientId, fpId, goalId, whatIfTemplate.WhatIfType);
    fetchInitialPlanImpact(clientId, fpId, goalId, whatIf, whatIfTemplate);
  }

  componentDidUpdate(previousProps) {
    const {
      clientId,
      fpId,
      goalId,
      whatIf,
      fetchPlanImpact,
      whatIfTemplate,
      educationType,
      yearlyCost,
      specificCollegeInformation,
    } = this.props;

    if (
      whatIf.IsSpecificCollege !== previousProps.whatIf.IsSpecificCollege
      && specificCollegeInformation
    ) {
      fetchPlanImpact(clientId, fpId, goalId, whatIf, whatIfTemplate);
      return;
    }

    if (educationType === EDUCATION_TYPE_OTHER || whatIf.IsSpecificCollege) {
      if (yearlyCost !== previousProps.yearlyCost) {
        fetchPlanImpact(clientId, fpId, goalId, whatIf, whatIfTemplate);
        return;
      }
    }
    if (educationType !== previousProps.educationType) {
      if (educationType === EDUCATION_TYPE_OTHER && (yearlyCost === 0 || !isNumeric(yearlyCost))) {
        return;
      }
      fetchPlanImpact(clientId, fpId, goalId, whatIf, whatIfTemplate);
    }
  }

  // when someone tries to type a custom amount, the what if should automatically shift to “other”
  onYearlyCostFocus() {
    const {
      clientId, goalId, whatIfTemplate, storeData, educationType,
    } = this.props;
    if (educationType !== EDUCATION_TYPE_OTHER) {
      storeData(goalId, whatIfTemplate.WhatIfType)(
        {
          WhatIf: {
            EducationType: EDUCATION_TYPE_OTHER,
          },
        },
        clientId,
      );
    }
  }

  onMoneyInputBlur(apiPath) {
    return (valueArg) => {
      const {
        goalId, clientId, whatIfTemplate, storeData,
      } = this.props;
      let value = valueArg;
      if (isNumericFormatted(valueArg)) {
        if (typeof valueArg === 'string') {
          value = +valueArg.replace(/[,]/g, '');
        }
      } else {
        value = 0;
      }
      advInputTextChanged(clientId, storeData(goalId, whatIfTemplate.WhatIfType), apiPath)(value);
    };
  }

  render() {
    const {
      goalId,
      clientId,
      loading,
      groupTitle,
      fpId,
      whatIf,
      whatIfTemplate,
      applyWhatIf,
      areOptionsLoaded,
      planImpactItems,
      storeData,
      yearsOptions,
      yearlyCost,
      educationType,
      specificCollegeInformation,
    } = this.props;

    const { ADV } = window;

    const {
      IsSpecificCollege: isSpecificCollege,
      SpecificCollegeIsInState: specificCollegeIsInState,
      SpecificCollegeIsPublic: specificCollegeIsPublic,
      SpecificCollegeName: specificCollegeName,
    } = whatIf;

    const costType = isSpecificCollege ? SPECIFIC_SCHOOL : NATIONAL_AVERAGE;

    const tuitionType = specificCollegeIsInState ? IN_STATE : OUT_OF_STATE;

    return (
      <div className="what-ifs-layout">
        {loading && <Loading />}
        <div className="what-ifs-section what-ifs-layout-header">
          <h3>What-If...</h3>
        </div>
        <div className="what-ifs-layout-content">
          <h4 className="what-if-group-title">{groupTitle}</h4>
          <AdvForm>
            <ValidationErrors clientId={clientId} />

            <ul className={`what-ifs-form-fields what-ifs-box${areOptionsLoaded ? ' loaded' : ''}`}>
              <li className="what-ifs-form-field">
                <h5 className="what-if-title">We change the cost type?</h5>
              </li>
              <li className="what-ifs-education-school-type-form-field">
                {costTypeOptions.map(({ label, value: costTypeValue }) => (
                  <label
                    htmlFor={`costType-${costTypeValue}`}
                    className={`
                      what-ifs-education-radio-container
                      ${costTypeValue === costType ? 'what-ifs-education-radio-selected' : ''}
                    `}
                  >
                    <div className="what-ifs-education-type-title">{label}</div>
                    <input
                      type="radio"
                      name="costType"
                      id={`costType-${costTypeValue}`}
                      value={costTypeValue}
                      checked={costTypeValue === costType}
                      onChange={({ target: { value } }) => {
                          storeData(goalId, whatIfTemplate.WhatIfType)({
                            WhatIf: { IsSpecificCollege: +value === SPECIFIC_SCHOOL },
                          }, clientId);

                          if (+value === SPECIFIC_SCHOOL) {
                            storeData(goalId, whatIfTemplate.WhatIfType)({
                              WhatIf: { SpecificCollegeName: '' },
                            }, clientId);
                          }
                        }}
                    />
                    <div className="what-ifs-education-radio-checkmark" />
                  </label>
                ))}
              </li>
            </ul>

            {isSpecificCollege ? [
              <ul className={`what-ifs-form-fields what-ifs-box${areOptionsLoaded ? ' loaded' : ''}`}>
                <li className="what-ifs-form-field">
                  <h5 className="what-if-title">School Name</h5>
                </li>
                <li className="what-ifs-education-school-type-form-field">
                  <SchoolSearch
                    inputWrapperClassName="what-ifs-education-school-search"
                    className="what-ifs-input"
                    clientId={clientId}
                    value={specificCollegeName || ''}
                    htmlPlaceholder="Search for a school..."
                    onChange={(selectedSchool) => {
                      storeData(goalId, whatIfTemplate.WhatIfType)({
                        WhatIf: {
                          SpecificCollegeName: selectedSchool.Name,
                          SpecificCollegeInformation: typeof selectedSchool === 'string' ? null : selectedSchool,
                        },
                      }, clientId);

                      if (typeof selectedSchool !== 'string') {
                        storeData(goalId, whatIfTemplate.WhatIfType)({
                          WhatIf: {
                            SpecificCollegeIsPublic: !selectedSchool.IsPrivate,
                            YearlyCost: selectedSchool.InStateTotal,
                            SpecificCollegeIsInState: true,
                          },
                          Options: { SpecificCollegeInformation: selectedSchool },
                        }, clientId);
                      }
                    }}
                  />
                </li>
              </ul>,
              specificCollegeInformation && specificCollegeIsPublic && (
                <ul className={`what-ifs-form-fields what-ifs-box${areOptionsLoaded ? ' loaded' : ''}`}>
                  <li className="what-ifs-form-field">
                    <h5 className="what-if-title">Tuition Type</h5>
                  </li>
                  <li className="what-ifs-education-school-type-form-field">
                    {tuitionTypeOptions.map(({ label, value: tuitionTypeValue }) => (
                      <label
                        htmlFor={`educationType-${tuitionTypeValue}`}
                        className={`
                          what-ifs-education-radio-container
                          ${tuitionType === tuitionTypeValue ? 'what-ifs-education-radio-selected' : ''}
                        `}
                      >
                        <div className="what-ifs-education-type-title">{label}</div>
                        <input
                          type="radio"
                          name="educationType"
                          id={`educationType-${tuitionTypeValue}`}
                          value={tuitionTypeValue}
                          checked={tuitionTypeValue === tuitionType}
                          onChange={({ target: { value } }) =>
                            storeData(goalId, whatIfTemplate.WhatIfType)({
                              WhatIf: {
                                SpecificCollegeIsInState: +value === IN_STATE,
                                YearlyCost: +value === IN_STATE
                                  ? specificCollegeInformation.InStateTotal
                                  : specificCollegeInformation.OutOfStateTotal,
                              },
                            }, clientId)
                          }
                        />
                        <div className="what-ifs-education-radio-checkmark" />
                      </label>
                    ))}
                  </li>
                </ul>
                ),
            ] : (
              <ul className={`what-ifs-form-fields what-ifs-box${areOptionsLoaded ? ' loaded' : ''}`}>
                <li className="what-ifs-form-field">
                  <h5 className="what-if-title">School Type</h5>
                </li>
                <li className="what-ifs-education-school-type-form-field">
                  {yearsOptions.map(({ type, title: optionTitle, description }) => {
                    if (type === EDUCATION_TYPE_OTHER) {
                      return (
                        <div
                          className={`what-ifs-education-radio-button-with-input${
                            type === educationType ? ' what-ifs-education-radio-selected' : ''
                          }`}
                        >
                          <label
                            htmlFor={`educationType-${type}`}
                            className="what-ifs-education-radio-container"
                          >
                            <div className="what-ifs-education-type-title">{optionTitle}</div>
                            <div className="what-ifs-education-type-description">{description}</div>
                            <input
                              type="radio"
                              name="educationType"
                              id={`educationType-${type}`}
                              value={type}
                              checked={educationType === type}
                              onChange={inputNumericRadioClicked(
                                clientId,
                                storeData(goalId, whatIfTemplate.WhatIfType),
                                'WhatIf.EducationType',
                              )}
                            />
                            <div className="what-ifs-education-radio-checkmark" />
                          </label>
                          <AdvInputWrapper
                            hasCurrency
                            className="what-ifs-education-input-wrapper-with-radio"
                          >
                            <AdvInput
                              autoComplete="off"
                              type="text"
                              dataType="money"
                              maxLength="14"
                              onFocus={this.onYearlyCostFocus}
                              onBlur={this.onMoneyInputBlur('WhatIf.YearlyCost')}
                              value={ADV.util.formatValue(yearlyCost, 'money')}
                              className="what-ifs-input"
                            />
                          </AdvInputWrapper>
                        </div>
                      );
                    }
                    return (
                      <label
                        htmlFor={`educationType-${type}`}
                        className={`what-ifs-education-radio-container${
                          type === educationType ? ' what-ifs-education-radio-selected' : ''
                        }`}
                      >
                        <div className="what-ifs-education-type-title">{optionTitle}</div>
                        <div className="what-ifs-education-type-description">{description}</div>
                        <input
                          type="radio"
                          name="educationType"
                          id={`educationType-${type}`}
                          value={type}
                          checked={educationType === type}
                          onChange={inputNumericRadioClicked(
                            clientId,
                            storeData(goalId, whatIfTemplate.WhatIfType),
                            'WhatIf.EducationType',
                          )}
                        />
                        <div className="what-ifs-education-radio-checkmark" />
                      </label>
                    );
                  })}
                </li>
              </ul>
            )}
          </AdvForm>
        </div>
        <PlanImpact clientId={clientId} planImpactItems={planImpactItems} />
        <Footer
          clientId={clientId}
          applyToPlanCallback={applyWhatIf(clientId, fpId, goalId, whatIf, whatIfTemplate)}
        />
      </div>
    );
  }
}
SchoolTypeChangesView.defaultProps = {
  groupTitle: 'Untitled What If Group',
  educationType: -1,
  yearlyCost: '',
  specificCollegeInformation: null,
};

SchoolTypeChangesView.propTypes = {
  planImpactItems: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string.isRequired,
    current: PropTypes.string.isRequired,
    proposed: PropTypes.string.isRequired,
  })).isRequired,
  yearsOptions: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  goalId: createCustomPropType(isUuid).isRequired,
  fpId: createCustomPropType(isUuid).isRequired,
  clientId: createCustomPropType(isNumeric).isRequired,
  groupTitle: PropTypes.string,
  areOptionsLoaded: PropTypes.bool.isRequired,
  whatIf: PropTypes.shape({}).isRequired,
  whatIfTemplate: PropTypes.shape({}).isRequired,
  fetchData: PropTypes.func.isRequired,
  storeData: PropTypes.func.isRequired,
  loading: PropTypes.bool.isRequired,
  fetchInitialPlanImpact: PropTypes.func.isRequired,
  fetchPlanImpact: PropTypes.func.isRequired,
  applyWhatIf: PropTypes.func.isRequired,
  educationType: PropTypes.number,
  yearlyCost: createCustomPropType(isNumeric),
  specificCollegeInformation: PropTypes.shape({}),
};

export default SchoolTypeChangesView;
